import type { SelectHTMLAttributes } from 'react';

export interface FormSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

/**
 * Native <select> styled to match TextInput (same height/radius/tokens), so the
 * ~9 pasted inline `selectCss` objects can be deleted. Works inside FormField
 * (which injects id for label association). Density-aware via --row-h.
 */
export function FormSelect({ invalid, style, children, ...rest }: FormSelectProps) {
  return (
    <select
      {...rest}
      style={{
        width: '100%',
        height: 40,
        padding: '0 12px',
        borderRadius: 'var(--r-2)',
        border: `1px solid ${invalid ? 'var(--danger)' : 'var(--glass-line-2)'}`,
        background: 'var(--surface)',
        color: 'var(--text)',
        fontSize: 'var(--t-md)',
        fontFamily: 'inherit',
        cursor: 'pointer',
        outline: 'none',
        ...style,
      }}
    >
      {children}
    </select>
  );
}
